export default (obj, value) => Object.keys(obj).find(key => obj[key] === value);
